import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faClock, 
  faUtensils,
  faCalendar,
  faPhone,
  faLeaf,
  faMapMarkerAlt,
  faWineGlass,
  faTicketAlt,
  faPercent,
  faArrowRight
} from '@fortawesome/free-solid-svg-icons';
import ParallaxBanner from '../../common/Parralax-banner';
import Footer from '../../Footer/Footer';
import { Link } from 'react-router-dom';
import SEO from '../../common/SEO';
const seasoningVideo = '/videos/seasoning.mp4';

const breakfastImg = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/breakfast.webp';
const eggsImg = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/eggs.webp';
const coffeeImg = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/coffee.webp';
const toastImg = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/toast.webp';
const tapas = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/tapas.webp';
const bistroImage = 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/bistro.webp';

const lager = 'https://BelvoirCastle.b-cdn.net/Castle/lager.webp';

const balloonImage = 'https://BelvoirCastle.b-cdn.net/Balloon%20bar/balloon.webp';
const balloonBar = 'https://BelvoirCastle.b-cdn.net/Balloon%20bar/ballonBar.webp';
const castleGin = 'https://BelvoirCastle.b-cdn.net/Balloon%20bar/castleGin.webp';
const cocktail = 'https://BelvoirCastle.b-cdn.net/Balloon%20bar/cocktail.webp';
const garnishCocktail = 'https://BelvoirCastle.b-cdn.net/Balloon%20bar/garnishCocktail.webp';
const makingCocktail = 'https://BelvoirCastle.b-cdn.net/Balloon%20bar/makingCocktail.webp';

const galleryPhotos = [
  { src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/pizza.webp', alt: 'A wood-fired pizza', title: 'Wood-fired Pizza', size: 'feature' },
  { src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/EX2A6999.webp', alt: 'A breakfast table with a full English and fresh fruit', title: 'Breakfast Table', size: 'wide' },
  { src: eggsImg, alt: 'Fresh eggs benedict', title: 'Breakfast Classics' },
  { src: coffeeImg, alt: 'Freshly brewed coffee', title: 'Barista Coffee' },
  { src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/EX2A7002.webp', alt: 'Fish and chips, crispy chicken and a burger', title: 'From the Kitchen', size: 'feature' },
  { src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/chicken-1.webp', alt: 'Crispy chicken with chips and coleslaw', title: 'Crispy Chicken', size: 'feature' },
  { src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/EX2A7037.webp', alt: 'Glasses of Belvoir red and white wine', title: 'Belvoir Wine', size: 'wide' },
  { src: tapas, alt: 'Tapas with wine and beer', title: 'Tapas', size: 'wide' },
  { src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/EX2A6950.webp', alt: 'Eggs royale with smoked salmon', title: 'Eggs Royale' },
  { src: 'https://BelvoirCastle.b-cdn.net/Retail%20village/Bistro/EX2A7061.webp', alt: 'Tacos served with chips', title: 'Tacos' },
  { src: toastImg, alt: 'Toasted bread with Belvoir butter', title: 'Fresh Baked Goods' },
  { src: breakfastImg, alt: 'Full breakfast spread', title: 'Morning Delights' }
];


const BistroContainer = styled.div`
  min-height: 100vh;
  padding-top: 120px;
`;

const VideoHero = styled.div`
  position: relative;
  height: 90vh;
  overflow: hidden;
  
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
  }
`;

const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.4) 50%,
    rgba(0, 0, 0, 0.6) 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  z-index: 2;
`;

const HeroTitle = styled.h1`
  font-size: 5rem;
  font-family: ${props => props.theme.fonts.main};
  margin-bottom: 1.5rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    font-size: 3.5rem;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.8rem;
  max-width: 800px;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
  line-height: 1.4;
  padding: 0 2rem;
  
  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

const ContentContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 4rem 2rem;
`;

const Section = styled.section`
  margin: 6rem 0;
`;

const SectionTitle = styled.h2`
  font-family: ${props => props.theme.fonts.main};
  font-size: 2.5rem;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 2rem;
  text-align: center;
  position: relative;
`;


const VideoGallery = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const VideoCard = styled.div`
  position: relative;
  height: 300px;
  overflow: hidden;
  border-radius: 15px;
  
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const InfoCard = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);

  svg {
    font-size: 2rem;
    color: ${props => props.theme.colors.primary};
    margin-bottom: 1rem;
  }
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 3rem;
  margin: 4rem 0;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  text-align: center;
  
  svg {
    font-size: 2.5rem;
    color: ${props => props.theme.colors.accent};
    margin-bottom: 1.5rem;
  }
  
  h3 {
    font-size: 1.8rem;
    color: ${props => props.theme.colors.primary};
    margin-bottom: 1rem;
  }
  
  p {
    font-size: 1.1rem;
    line-height: 1.6;
    color: ${props => props.theme.colors.secondary};
  }
`;

const MenuSection = styled.div`
  margin: 5rem 0;
`;


const ScrollIndicator = styled.div`
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  cursor: pointer;
  animation: bounce 2s infinite;

  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateX(-50%) translateY(0);
    }
    40% {
      transform: translateX(-50%) translateY(-10px);
    }
    60% {
      transform: translateX(-50%) translateY(-5px);
    }
  }

  svg {
    width: 40px;
    height: 40px;
    fill: none;
    stroke: white;
    stroke-width: 2;
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.3));
    opacity: 0.8;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 1;
    }
  }
`;

const MembershipSection = styled.section`
  background: ${props => props.theme.colors.greyBackground};
  padding: 4rem 0;
  text-align: center;
`;

const MembershipCard = styled.div`
  background: white;
  max-width: 800px;
  margin: 0 auto;
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
`;

const MembershipIcon = styled.div`
  width: 80px;
  height: 80px;
  background: ${props => props.theme.colors.accent};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  
  svg {
    color: white;
    font-size: 2.5rem;
  }
`;

const MembershipButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  background-color: ${props => props.theme.colors.accent};
  color: white;
  text-decoration: none;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: ${props => props.theme.shadows.light};
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    background-color: ${props => {
      // Darken the accent color slightly on hover
      const color = props.theme.colors.accent;
      return `${color}dd`;
    }};
  }
  
  &:active {
    transform: translateY(0);
  }
  
  svg {
    margin-left: 0.5rem;
  }
`;

const IntroText = styled.p`
  font-size: 1.2rem;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
`;

const BenefitsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
`;

const BenefitItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
`;

const BenefitText = styled.span`
  margin-left: 0.5rem;
`;

const MenuButton = styled.a`
  display: inline-flex;
  align-items: center;
  background-color: ${props => props.theme.colors.accent};
  color: white;
  text-decoration: none;
  padding: 1.2rem 2.5rem;
  border-radius: 25px;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  box-shadow: ${props => props.theme.shadows.light};
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    background-color: ${props => {
      // Darken the accent color slightly on hover
      const color = props.theme.colors.accent;
      return `${color}dd`;
    }};
  }
  
  &:active {
    transform: translateY(0);
  }
  
  svg {
    margin-left: 0.5rem;
  }
`;

const MenuButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  text-align: center;
  margin: 3rem 0 0;
`;

const MenuTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem;
  margin: 2rem 0 1.5rem;
`;

const MenuTab = styled.button`
  background: ${props => props.$active ? props.theme.colors.primary : 'transparent'};
  color: ${props => props.$active ? 'white' : props.theme.colors.primary};
  border: 2px solid ${props => props.theme.colors.primary};
  border-radius: 999px;
  padding: 0.7rem 1.4rem;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background: ${props => props.theme.colors.primary};
    color: white;
  }
`;

const MenuSubTabs = styled(MenuTabs)`
  margin: 0 0 1.5rem;
`;

const MenuSubTab = styled(MenuTab)`
  padding: 0.45rem 1rem;
  font-size: 0.95rem;
  border-color: ${props => props.theme.colors.accent};
  background: ${props => props.$active ? props.theme.colors.accent : 'transparent'};
  color: ${props => props.$active ? 'white' : props.theme.colors.accent};

  &:hover {
    background: ${props => props.theme.colors.accent};
    color: white;
  }
`;

const MenuNote = styled.p`
  text-align: center;
  font-size: 1.05rem;
  line-height: 1.6;
  color: ${props => props.theme.colors.secondary};
  margin: 0 auto 1.5rem;
  max-width: 720px;
`;

const MenuKey = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem 1.5rem;
  margin: 0 auto 1.5rem;
`;

const MenuKeyItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.95rem;
  color: ${props => props.theme.colors.secondary};
`;

const MenuGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const MenuGroupTitle = styled.h3`
  grid-column: 1 / -1;
  text-align: center;
  font-size: 1.6rem;
  color: ${props => props.theme.colors.primary};
  margin: 0.5rem 0 0;
`;

const MenuItem = styled.article`
  background: #f7f4ef;
  border-radius: 12px;
  padding: 1.25rem 1.4rem;
`;

const MenuItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
`;

const MenuItemTitle = styled.h3`
  font-size: 1.35rem;
  color: ${props => props.theme.colors.primary};
  margin: 0;
`;

const MenuItemPrice = styled.span`
  color: ${props => props.theme.colors.accent};
  font-weight: 600;
  white-space: nowrap;
`;

const MenuPriceLine = styled.p`
  color: ${props => props.theme.colors.accent};
  font-size: 1rem;
  line-height: 1.5;
  margin: 0.35rem 0 0;
`;

const MenuItemDescription = styled.p`
  margin: 0.45rem 0 0;
  font-size: 1rem;
  line-height: 1.5;
  color: ${props => props.theme.colors.secondary};
`;

const MenuItemTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-top: 0.75rem;
`;

const MenuItemTag = styled.span`
  background: ${props => props.theme.colors.primary};
  color: white;
  border-radius: 999px;
  padding: 0.15rem 0.55rem;
  font-size: 0.8rem;
  font-weight: 600;
`;

const bistroMenu = [
  {
    id: 'breakfast',
    label: 'Breakfast',
    note: 'Available till 12 noon',
    groups: [
      {
        items: [
          { title: 'The Bistro Full English', price: '£14.95', description: 'Bacon, sausage, scrambled egg, field mushroom, hash brown, tomato, beans and toast. Vegetarian option available.' },
          { title: 'Smoked Bacon or Estate Sausage', price: '£7.95', description: 'With tomato chutney, served on a brioche roll.' },
          { title: 'Eggs Benedict', price: '£12.95', description: 'Crispy pancetta and hollandaise on English muffins.' },
          { title: 'Primavera', price: '£11.95', description: 'Smashed avocado and vine tomatoes. Add poached egg £2.50.', tags: ['V'] },
          { title: 'Scrambled Eggs & Smoked Salmon', price: '£12.95', description: 'On toasted bloomer.' },
          { title: 'Rarebit on Toasted Bloomer', price: '£11.95', description: 'With roasted vine tomatoes or pancetta.' },
          { title: 'Selection of Toasted Breads or Panettone', price: '£4.95', description: 'With butter and preserves.' },
          { title: 'Fresh Fruit and Berry Granola', price: '£6.95', description: 'With Greek yoghurt and honey.' },
          { title: 'Fruit Scone', price: '£3.60', description: 'Served with butter and preserves.' },
        ],
      },
    ],
  },
  {
    id: 'light-bites',
    label: 'Light Bites',
    groups: [
      {
        items: [
          { title: 'Soup of the Day', price: '£8.95', description: 'Served with warm bread. Please ask your server for today’s choices.' },
          { title: 'Selection of Breads', price: '£9.95', description: 'With dipping oils.' },
          { title: 'Baked Camembert', price: '£11.25', description: 'Warm bread and sweet chilli dip.' },
          { title: 'Classic Bruschetta', price: '£10.25', description: 'Heritage tomatoes, parmesan, peppers and balsamic glaze.', tags: ['V'] },
          { title: 'Tempura Battered King Prawns', price: '£11.95', description: 'With a sweet chilli mayo.' },
          { title: 'Warm Scotch Egg', price: '£7.95', description: 'Served with tomato chutney and pickles.' },
          { title: 'Classic Cheese Souffle', price: '£12.95', description: 'Served with cream cheese and smoked salmon.' },
          { title: 'Pork Sausage Roll', price: '£7.95', description: 'Served with autumn chutney and pickles.' },
        ],
      },
    ],
  },
  {
    id: 'sandwiches',
    label: 'Sandwiches',
    note: 'Served with salad and fries.',
    groups: [
      {
        items: [
          { title: 'New Yorker', price: '£14.95', description: 'Pastrami, Swiss cheese, gherkin and yellow mustard.' },
          { title: 'Classic BLT', price: '£14.95' },
          { title: 'Chicken, Bacon & Brie', price: '£14.95' },
          { title: 'Roasted Ham and Swiss Cheese', price: '£14.95' },
          { title: 'Mediterranean Tuna', price: '£14.95' },
          { title: 'Smoked Salmon & Cream Cheese', price: '£14.95' },
          { title: 'Brie, Grilled Vegetables with Greek Yoghurt', price: '£14.95', tags: ['V'] },
        ],
      },
    ],
  },
  {
    id: 'classics',
    label: 'Classics',
    groups: [
      {
        items: [
          { title: 'Steak and Red Onion Focaccia', price: '£17.95', description: 'With fries and deli slaw.' },
          { title: 'Breaded Chicken Parmigiana', price: '£17.95', description: 'Served with skin on fries, rocket and parmesan.' },
          { title: 'Classic Fish and Chips', price: '£17.95', description: 'Haddock, crushed peas, homemade tartare and skin on fries.' },
          { title: 'Tempura Battered Fish Finger Focaccia', price: '£16.95', description: 'Served with tartare mayonnaise, deli slaw and skin on fries.' },
          { title: 'Fillet of Salmon', price: '£18.65', description: 'On a bed of Mediterranean vegetable risotto.' },
          { title: 'Roasted Mediterranean Vegetable Risotto', price: '£16.25', tags: ['V'] },
          { title: 'Lasagne al Forno / Spicy Mac n Cheese', price: '£16.95', description: 'Served with garlic ciabatta. Spicy Mac n Cheese is vegetarian.' },
          { title: 'Steak Frites', price: '£17.95', description: 'Add pepper, garlic butter or chimichurri £2.00.' },
          { title: 'Filled Yorkshire Puddings', price: '£16.95', description: 'Choice of beef bourguignon, sausage and mash, or cauliflower cheese.' },
        ],
      },
    ],
  },
  {
    id: 'salads',
    label: 'Salads',
    groups: [
      {
        items: [
          { title: 'Grilled Chicken Caesar Salad', price: '£16.95', description: 'With crispy pancetta and croutons.' },
          { title: 'King Prawn and Avocado Salad', price: '£16.95' },
          { title: 'Tuna Nicoise', price: '£16.95' },
          { title: 'Steak, Avocado and Potato Salad', price: '£17.95', description: 'With a fresh mint and garlic dressing, and croutons.' },
          { title: 'Classic Caprese', price: '£14.95', description: 'Burrata mozzarella, tomatoes and fresh basil leaves.', tags: ['V'] },
          { title: 'Mediterranean Vegetable Tart', price: '£15.95', description: 'Served with skin on fries.' },
        ],
      },
    ],
  },
  {
    id: 'sides',
    label: 'Sides',
    groups: [
      {
        items: [
          { title: 'Garlic Bread with Cheese', price: '£8.75' },
          { title: 'Mixed Olives', price: '£3.95' },
          { title: 'Skin on Fries', price: '£4.95' },
          { title: 'Truffle & Parmesan Fries', price: '£6.95' },
          { title: 'Seasonal Greens', price: '£4.95' },
          { title: 'Mixed House Salad', price: '£4.95' },
        ],
      },
    ],
  },
  {
    id: 'pizza',
    label: 'Pizza',
    groups: [
      {
        items: [
          { title: 'Margarita', price: '£12.95' },
          { title: 'Pepperoni', price: '£16.95' },
          { title: 'Seafood', price: '£19.95' },
          { title: 'Carbonara', price: '£16.95' },
          { title: 'Vegetarian', price: '£15.95' },
          { title: 'Barbecue Chicken', price: '£16.95' },
        ],
      },
    ],
  },
  {
    id: 'desserts',
    label: 'Desserts',
    note: 'All £8.95, served with ice cream or vanilla cream.',
    groups: [
      {
        items: [
          { title: 'Chocolate Fudge Cake', price: '£8.95' },
          { title: 'Chocolate & Caramel Tart', price: '£8.95', tags: ['Vg', 'Gf'] },
          { title: 'Warm Apple Strudel', price: '£8.95' },
          { title: 'Raspberry & White Chocolate Cheesecake', price: '£8.95' },
          { title: 'Strawberry and Cream Sponge Slice', price: '£8.95', tags: ['Gf'] },
          { title: 'Lemon Meringue Tart', price: '£8.95' },
          { title: 'Tarte Tatin', price: '£8.95' },
          { title: 'Belgian Chocolate Pudding', price: '£8.95' },
          { title: 'Selection of Hand Made Cake', price: 'from £6.95' },
        ],
      },
    ],
  },
  {
    id: 'drinks',
    label: 'Drinks',
    sections: [
  {
    id: 'cocktails',
    label: 'Cocktails',
    groups: [
      {
        items: [
          { title: 'Aperol Spritz', price: '£10.25', description: 'Traditional Italian aperitif served with prosecco.' },
          { title: 'Bellini', price: '£10.25', description: 'The classic Italian cocktail invented at Harry’s Bar in Venice. Choice of peach, raspberry, passion fruit or strawberry.' },
          { title: 'Italian Bucks Fizz', price: '£10.25', description: 'Served with orange juice, triple sec and prosecco.' },
          { title: 'Cin Cin Malfy Gin & Tonic', price: '£10.25', description: 'Originale, Limone, Arancia or Rosa.' },
          { title: 'Traditional Pimms', price: '£10.25', description: 'Served with fresh fruits and prosecco.' },
          { title: 'Elderflower Spritz', price: '£10.25', description: 'Elderflower liqueur and prosecco.' },
          { title: 'Vibrante Spritz', price: '£8.95', description: 'Non-alcoholic vibrant spritz.' },
        ],
      },
    ],
  },
  {
    id: 'hot-drinks',
    label: 'Hot Drinks',
    note: 'Coffee prices are regular, then large. Dairy alternatives available: soya, oat and coconut.',
    groups: [
      {
        items: [
          { title: 'Cappuccino', prices: ['Regular £3.90', 'Large £4.50'] },
          { title: 'Cappuccino Viennese', prices: ['Regular £4.10', 'Large £4.70'] },
          { title: 'Caffe Latte', prices: ['Regular £3.90', 'Large £4.50'] },
          { title: 'Caffe Mocha', prices: ['Regular £4.15', 'Large £4.75'] },
          { title: 'Americano', prices: ['Regular £3.60', 'Large £4.20'] },
          { title: 'Espresso', prices: ['Regular £3.20', 'Large £3.60'] },
          { title: 'Espresso Macchiato', prices: ['Regular £3.30', 'Large £3.70'] },
          { title: 'Flat White', price: '£4.00' },
          { title: 'Extra Shot Espresso', price: '£0.75' },
          { title: 'Flavoured Shots', price: '£0.85' },
        ],
      },
      {
        items: [
          { title: 'Hot Chocolate', price: '£4.95', description: 'Served with whipped cream and mini marshmallows.' },
          { title: 'Pot of Traditional Tea', price: '£3.20' },
          { title: 'Pot of Speciality Tea', price: '£3.40', description: 'Please ask your server for the choice of teas.' },
          { title: 'Iced Frappuccino', price: '£5.50', description: 'Topped with vanilla whipped cream.' },
        ],
      },
      {
        title: 'Complement your coffee with',
        items: [
          { title: 'Italian Biscotti', price: '£1.00' },
          { title: 'Sicilian Cannoli', price: '£1.60' },
          { title: 'Sicilian Aragostine', price: '£1.60' },
        ],
      },
    ],
  },
  {
    id: 'cold-drinks',
    label: 'Cold Drinks',
    groups: [
      {
        items: [
          { title: 'Pepsi', price: '£3.60' },
          { title: 'Diet Pepsi', price: '£3.35' },
          { title: 'Fresh Juice', price: '£3.40', description: 'Orange, passion fruit, cranberry or apple.' },
          { title: 'San Pellegrino Sparkling Fruit Juice', price: '£3.40', description: 'Lemon, orange or blood orange.' },
          { title: 'Belvoir Elderflower Presse', price: '£3.40' },
          { title: 'Belvoir Raspberry Lemonade', price: '£3.40' },
          { title: 'Belvoir Ginger Beer', price: '£3.40' },
          { title: 'Spring Water', prices: ['Regular bottle £3.15', 'Large bottle £4.80'], description: 'Still or sparkling.' },
        ],
      },
    ],
  },
  {
    id: 'wine',
    label: 'Wine',
    note: 'Wine by the glass is also available as a 125ml.',
    groups: [
      {
        title: 'Prosecco & Champagne',
        items: [
          { title: 'Banda Rossa DOCG', prices: ['Glass £8.95', 'Bottle £50.00'] },
          { title: 'House Prosecco DOC', prices: ['Glass £8.75', 'Bottle £49.00'] },
          { title: 'Filanda Pinot Noir Rosé', prices: ['Glass £8.95', 'Bottle £50.00'] },
          { title: 'Belvoir Sparkling Rosé', price: '£50.00', description: 'Bottle.' },
          { title: 'Veuve Clicquot', price: '£99.00', description: 'Bottle.' },
          { title: 'Laurent-Perrier Cuvée Rosé', price: '£120.00', description: 'Bottle.' },
        ],
      },
      {
        title: 'Reds',
        items: [
          { title: 'Cabernet Sauvignon', prices: ['175ml £7.25', '250ml £10.25', 'Bottle £29.00'] },
          { title: 'Chianti', prices: ['175ml £7.25', '250ml £10.25', 'Bottle £29.00'] },
          { title: 'Belvoir Estate Rutland Red', prices: ['175ml £7.25', '250ml £10.25', 'Bottle £29.00'] },
        ],
      },
      {
        title: 'Whites',
        items: [
          { title: 'Sauvignon', prices: ['175ml £7.25', '250ml £10.25', 'Bottle £29.00'] },
          { title: 'Pinot Grigio', prices: ['175ml £7.25', '250ml £10.25', 'Bottle £29.00'] },
          { title: 'Belvoir Estate Rutland White', prices: ['175ml £7.25', '250ml £10.25', 'Bottle £29.00'] },
        ],
      },
      {
        title: 'Rosé',
        items: [
          { title: 'Pinot Grigio Rosé', prices: ['175ml £7.25', '250ml £10.25', 'Bottle £29.00'] },
        ],
      },
    ],
  },
  {
    id: 'beer',
    label: 'Beer & Cider',
    groups: [
      {
        items: [
          { title: 'Peroni Nastro 33cl', price: '£5.00', description: '5.1% ABV.' },
          { title: 'Peroni Gran Riserva 33cl', price: '£5.95', description: '6.6% ABV.' },
          { title: 'Peroni (Gluten free) 33cl', price: '£5.00', description: '5.1% ABV.' },
          { title: 'Peroni Zero 33cl', price: '£4.90', description: '0% ABV.' },
          { title: 'Belvoir Estate Cider 50cl', price: '£6.50', description: '6% ABV.' },
          { title: 'Belvoir Estate Ale 50cl', price: '£6.50', description: '6% ABV.' },
          { title: 'Moretti on Draught', prices: ['Half £3.25', 'Pint £6.50'], description: '4.6% ABV.' },
        ],
      },
    ],
  },
    ],
  },
];

const GallerySection = styled.section`
  padding: 6rem 0;
  background: white;
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 240px;
  grid-auto-flow: dense;
  gap: 1.5rem;
  padding: 0 2rem;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: 250px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 200px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    grid-auto-rows: 220px;
  }
`;

const GalleryItem = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  grid-column: ${props => props.$size === 'feature' || props.$size === 'wide' ? 'span 2' : 'span 1'};
  grid-row: ${props => props.$size === 'feature' ? 'span 2' : 'span 1'};

  &:hover {
    transform: scale(1.02);
  }

  @media (max-width: 480px) {
    grid-column: span 1;
    grid-row: span 1;
  }
`;

const GalleryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
`;

const GalleryOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  padding: 1.5rem;
  text-align: center;
`;

const GalleryTitle = styled.h3`
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
`;

const BelvoirBistro = () => {
  const [activeMenu, setActiveMenu] = React.useState('breakfast');
  const [activeDrink, setActiveDrink] = React.useState('cocktails');
  const currentMenu = bistroMenu.find((section) => section.id === activeMenu);
  const currentSection = currentMenu?.sections
    ? currentMenu.sections.find((section) => section.id === activeDrink)
    : currentMenu;

  return (
    <BistroContainer>
      <SEO 
        title="Belvoir Bistro - Retail Village Dining Experience"
        description="Enjoy fresh, locally-sourced cuisine at the Belvoir Bistro. Experience casual fine dining in the historic setting of Belvoir Castle with seasonal menus and spectacular views."
        keywords="Belvoir Bistro, castle dining, Leicestershire restaurants, fine dining, local cuisine, historic restaurant"
        canonicalUrl="https://www.belvoircastle.com/retail-village/dining/belvoir-bistro"
        ogImage={bistroImage}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Restaurant",
          "name": "Belvoir Bistro",
          "description": "Enjoy fresh, locally-sourced cuisine at the Belvoir Bistro. Experience casual fine dining in the historic setting of Belvoir Castle with seasonal menus and spectacular views.",
          "image": bistroImage,
          "servesCuisine": "British, Local",
          "priceRange": "££",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Belvoir Castle",
            "addressLocality": "Grantham",
            "addressRegion": "Leicestershire",
            "postalCode": "NG32 1PE",
            "addressCountry": "UK"
          },
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            "opens": "09:00",
            "closes": "17:00"
          },
          "menu": "https://www.belvoircastle.com/retail-village/dining/belvoir-bistro/menu",
          "acceptsReservations": true,
          "telephone": "+441476871001",
          "sameAs": [
            "https://www.facebook.com/belvoircastle",
            "https://www.instagram.com/belvoircastle",
            "https://twitter.com/belvoircastle"
          ]
        }}
      />
      <VideoHero>
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          controls={false}
          preload="auto"
          style={{ opacity: 0.9 }}
        >
          <source src={seasoningVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <VideoOverlay>
          <HeroTitle>The Belvoir Bistro</HeroTitle>
          <HeroSubtitle>A taste of tradition at the heart of Belvoir retail village</HeroSubtitle>
        </VideoOverlay>
        <ScrollIndicator onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}>
          <svg viewBox="0 0 24 24">
            <path d="M12 5L12 19M12 19L5 12M12 19L19 12" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </ScrollIndicator>
      </VideoHero>
      
      <ContentContainer>
        <Section>
          <SectionTitle>Our Philosophy</SectionTitle>
          <FeatureGrid>
            <FeatureCard>
              <FontAwesomeIcon icon={faLeaf} />
              <h3>Local & Seasonal</h3>
              <p>
                We pride ourselves on sourcing ingredients directly from the Belvoir Castle Estate 
                and trusted local suppliers. Our menu changes with the seasons, ensuring the 
                freshest produce and supporting our local community.
              </p>
            </FeatureCard>
            <FeatureCard>
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <h3>Castle Heritage</h3>
              <p>
                Located at the heart of the Belvoir retail village, our bistro combines centuries of history 
                with modern culinary excellence. Enjoy breathtaking views while savoring dishes 
                inspired by traditional British cuisine.
              </p>
            </FeatureCard>
            <FeatureCard>
              <FontAwesomeIcon icon={faUtensils} />
              <h3>Culinary Excellence</h3>
              <p>
                Our talented chefs blend traditional techniques with contemporary flair, 
                creating dishes that celebrate the rich culinary heritage of Belvoir Castle 
                while embracing modern gastronomy.
              </p>
            </FeatureCard>
            <FeatureCard>
              <FontAwesomeIcon icon={faWineGlass} />
              <h3>Carefully Curated</h3>
              <p>
                From our house-made breads to our selection of local ales and wines, 
                every element of your dining experience has been thoughtfully chosen 
                to reflect the excellence of Belvoir Castle.
              </p>
            </FeatureCard>
          </FeatureGrid>
        </Section>

        <MenuSection>
          <SectionTitle>Our Menu</SectionTitle>
          <MenuTabs role="tablist" aria-label="Bistro menu">
            {bistroMenu.map((section) => (
              <MenuTab
                key={section.id}
                type="button"
                role="tab"
                aria-selected={activeMenu === section.id}
                $active={activeMenu === section.id}
                onClick={() => setActiveMenu(section.id)}
              >
                {section.label}
              </MenuTab>
            ))}
          </MenuTabs>
          {currentMenu?.sections && (
            <MenuSubTabs role="tablist" aria-label="Drinks menu">
              {currentMenu.sections.map((section) => (
                <MenuSubTab
                  key={section.id}
                  type="button"
                  role="tab"
                  aria-selected={activeDrink === section.id}
                  $active={activeDrink === section.id}
                  onClick={() => setActiveDrink(section.id)}
                >
                  {section.label}
                </MenuSubTab>
              ))}
            </MenuSubTabs>
          )}
          <MenuKey aria-label="Menu key">
            <MenuKeyItem><MenuItemTag>V</MenuItemTag> Vegetarian</MenuKeyItem>
            <MenuKeyItem><MenuItemTag>Vg</MenuItemTag> Vegan</MenuKeyItem>
            <MenuKeyItem><MenuItemTag>Gf</MenuItemTag> Gluten free</MenuKeyItem>
          </MenuKey>
          {currentSection?.note && <MenuNote>{currentSection.note}</MenuNote>}
          <MenuGrid>
            {currentSection?.groups.map((group, groupIndex) => (
              <React.Fragment key={`${currentSection.id}-${groupIndex}`}>
                {group.title && <MenuGroupTitle>{group.title}</MenuGroupTitle>}
                {group.items.map((item) => (
                  <MenuItem key={item.title}>
                    <MenuItemHeader>
                      <MenuItemTitle>{item.title}</MenuItemTitle>
                      {item.price && <MenuItemPrice>{item.price}</MenuItemPrice>}
                    </MenuItemHeader>
                    {item.prices && <MenuPriceLine>{item.prices.join(' · ')}</MenuPriceLine>}
                    {item.description && <MenuItemDescription>{item.description}</MenuItemDescription>}
                    {item.tags && (
                      <MenuItemTags>
                        {item.tags.map((tag) => (
                          <MenuItemTag key={tag}>{tag}</MenuItemTag>
                        ))}
                      </MenuItemTags>
                    )}
                  </MenuItem>
                ))}
              </React.Fragment>
            ))}
          </MenuGrid>
          <MenuButtonContainer>
            <MenuButton
              href="https://www.belvoircastle.com/wp/wp-content/uploads/2026/04/Belvoir-Food-and-Drink-Packages.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Private Dining Packages <FontAwesomeIcon icon={faArrowRight} />
            </MenuButton>
          </MenuButtonContainer>
        </MenuSection>

        <GallerySection>
          <SectionTitle>Our Kitchen</SectionTitle>
          <GalleryGrid>
            {galleryPhotos.map((photo) => (
              <GalleryItem key={photo.src} $size={photo.size}>
                <GalleryImage src={photo.src} alt={photo.alt} />
                <GalleryOverlay className="overlay">
                  <GalleryTitle>{photo.title}</GalleryTitle>
                </GalleryOverlay>
              </GalleryItem>
            ))}
          </GalleryGrid>
        </GallerySection>

        <Section>
          <SectionTitle>Visit Us</SectionTitle>
          <InfoGrid>
            <InfoCard>
              <FontAwesomeIcon icon={faClock} />
              <h3>Opening Hours</h3>
              <p>Every day<br />9:00 - 17:00</p>
            </InfoCard>
            <InfoCard>
              <FontAwesomeIcon icon={faPhone} />
              <h3>Reservations</h3>
              <p>Call us<br />01476 247059</p>
            </InfoCard>
          </InfoGrid>
        </Section>

        <MembershipSection>
          <MembershipCard>
            <MembershipIcon>
              <FontAwesomeIcon icon={faTicketAlt} />
            </MembershipIcon>
            <SectionTitle>Friends of Belvoir Benefits</SectionTitle>
            <IntroText>
              Scan your membership card to enjoy exclusive benefits:
            </IntroText>
            <BenefitsList>
              <BenefitItem>
                <FontAwesomeIcon icon={faPercent} />
                <BenefitText>10% discount on all food and beverages</BenefitText>
              </BenefitItem>
            </BenefitsList>
            <MembershipButton to="/memberships">
              Become a Friend of Belvoir <FontAwesomeIcon icon={faArrowRight} />
            </MembershipButton>
          </MembershipCard>
        </MembershipSection>
      </ContentContainer>
      <Footer />
    </BistroContainer>
  );
};

export default BelvoirBistro; 